var map = {
	"./lang0.mp3": 1933,
	"./lang1.mp3": 1934,
	"./lang10.mp3": 1935,
	"./lang11.mp3": 1936,
	"./lang12.mp3": 1937,
	"./lang13.mp3": 1938,
	"./lang2.mp3": 1939,
	"./lang3.mp3": 1940,
	"./lang4.mp3": 1941,
	"./lang5.mp3": 1942,
	"./lang6.mp3": 1943,
	"./lang7.mp3": 1944,
	"./lang8.mp3": 1945,
	"./lang9.mp3": 1946
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1932;